import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const gameApi = {
  info: () => axios.get(`${API}/game/info`).then((r) => r.data),
  balance: (wallet) =>
    axios.get(`${API}/game/balance/${wallet}`).then((r) => r.data),
  pending: (wallet) =>
    axios.get(`${API}/game/pending/${wallet}`).then((r) => r.data),
  start: (wallet) =>
    axios
      .post(`${API}/game/start`, { wallet_address: wallet })
      .then((r) => r.data),
  end: (payload) =>
    axios.post(`${API}/game/end`, payload).then((r) => r.data),
  claim: (wallet) =>
    axios
      .post(`${API}/game/claim`, { wallet_address: wallet })
      .then((r) => r.data),
  leaderboard: (limit = 20) =>
    axios.get(`${API}/game/leaderboard`, { params: { limit } }).then((r) => r.data),
};
